import { useStore } from "../store/store";
import { useT } from "../i18n/useT";

export function ConsentLedger() {
  const t = useT();
  const consents = useStore((s) => s.consents);
  const contacts = useStore((s) => s.contacts);

  function nameFor(id: string): string {
    const c = contacts.find((x) => x.id === id);
    return c ? `${c.firstName} ${c.phoneE164}` : id;
  }

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-2xl font-semibold">{t.nav.consent}</h1>
        <p className="text-sm text-slate-500">Immutable consent artifacts. Every send pulls the latest record for the contact + channel.</p>
      </header>
      <div className="card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase text-slate-500 bg-slate-50">
            <tr>
              <th className="text-left p-3">Contact</th>
              <th className="text-left p-3">Channel</th>
              <th className="text-left p-3">{t.common.language}</th>
              <th className="text-left p-3">Status</th>
              <th className="text-left p-3">{t.contacts.source}</th>
              <th className="text-left p-3">{t.contacts.disclosureVersion}</th>
              <th className="text-left p-3">{t.contacts.timestamp}</th>
              <th className="text-left p-3">Evidence</th>
            </tr>
          </thead>
          <tbody>
            {consents.map((c) => (
              <tr key={c.id} className="border-t border-slate-100">
                <td className="p-3">{nameFor(c.contactId)}</td>
                <td className="p-3">{c.channel}</td>
                <td className="p-3 uppercase">{c.language}</td>
                <td className="p-3">
                  {c.status === "granted"
                    ? <span className="badge-ok">granted</span>
                    : <span className="badge-err">revoked</span>}
                </td>
                <td className="p-3">{c.source}</td>
                <td className="p-3 font-mono text-xs">{c.disclosureVersion}</td>
                <td className="p-3 font-mono text-xs">{new Date(c.at).toLocaleString()}</td>
                <td className="p-3 text-xs">
                  {c.evidenceUrl
                    ? <a href={c.evidenceUrl} target="_blank" rel="noreferrer" className="text-brand-700 hover:underline">link</a>
                    : <span className="text-slate-400">—</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
